import { Controller } from "@hotwired/stimulus"

// flash メッセージを一定時間後にフェード&スライドアウトで自動的に消す。
// `data-controller="flash"` を flash の wrapper 要素に付けて使う。
//
// 値:
//   data-flash-delay-value: 表示を維持するミリ秒数 (デフォルト 3000)
//   data-flash-fade-value:  退出アニメーションのミリ秒数 (デフォルト 200)
export default class extends Controller {
  static values = {
    delay: { type: Number, default: 3000 },
    fade: { type: Number, default: 200 },
  }

  connect() {
    // 入場アニメーション
    this.element.style.transition = `opacity ${this.fadeValue}ms ease-out, transform ${this.fadeValue}ms ease-out`
    this.element.style.opacity = "0"
    this.element.style.transform = "translateX(16px)"
    requestAnimationFrame(() => {
      this.element.style.opacity = "1"
      this.element.style.transform = "translateX(0)"
    })

    this.dismissTimer = setTimeout(() => this.dismiss(), this.delayValue)
  }

  disconnect() {
    if (this.dismissTimer) clearTimeout(this.dismissTimer)
  }

  dismiss() {
    this.element.style.opacity = "0"
    this.element.style.transform = "translateX(16px)"
    setTimeout(() => this.element.remove(), this.fadeValue)
  }
}
